<form data-qa="checkout-checkin-form" [formGroup]="formGroup">
  <div class="h-full p-4">
    <app-hotel-card [hotel]="data.hotel" />
    <div class="mt-7">
      @for (touristFormControl of formGroup.controls.touristIds.controls; track index; let index = $index) {
        <ng-container formArrayName="touristIds">
          <div class="flex flex-row gap-3 items-center w-full" [formGroupName]="index">
            <label class="w-1/4 mb-3" [for]="'hotel_guest_' + index">{{ 'Guest' | translate }} №{{ index + 1 }}</label>
            <app-selector
              optionValue="id"
              class="flex-1"
              placeholder="Select tourist"
              [options]="data.tourists | runFunction: applyIndexesForTouristsFn"
              [inputId]="'hotel_guest_' + index"
              [value]="touristFormControl.value"
              [errorMessage]="touristFormControl.touched ? touristFormControl.errors : null"
              (valueChange)="onGuestSelect(touristFormControl, $event)"
            >
              <ng-template #templateSelected let-option>
                <ng-container *ngTemplateOutlet="guestsSelectorTemplateRef; context: { option }" />
              </ng-template>
              <ng-template #templateOptionLabel let-option>
                <ng-container *ngTemplateOutlet="guestsSelectorTemplateRef; context: { option }" />
              </ng-template>
            </app-selector>
          </div>
        </ng-container>
      }
      <div class="flex flex-row gap-3 items-center mb-4 w-full">
        <label class="w-1/4 mb-3" for="hotel_agentConfirmationNumber">{{ 'Confirm №' | translate }}</label>
        <input
          id="hotel_agentConfirmationNumber"
          data-qa="checkout-checkin-confirmation-input"
          kzInput
          placeholder="Agent Confirmation Number"
          formControlName="agentConfirmationNumber"
          type="text"
        />
      </div>
      <div class="flex flex-row gap-3 items-center mb-4 w-full">
        <label class="w-1/4 mb-3" for="hotel_note" style="margin-bottom: 0 !important">{{ 'Note' | translate }}</label>
        <input kzInput id="hotel_note" data-qa="checkout-checkin-note-input" formControlName="note" type="text" />
      </div>
    </div>
  </div>
</form>
<ng-template #guestsSelectorTemplateRef let-option="option" [typedTemplate]="guestsSelectorTemplateTypedToken">
  @if (option.firstName && option.lastName) {
    {{ option.firstName }} {{ option.lastName }}
    @if (option.birthDate) {
      <span>({{ option.birthDate | date: dateFormat }})</span>
    }
  }
  @if (!option.firstName || !option.lastName) {
    {{ 'Tourist' | translate }} №{{ option._index }}
  }
</ng-template>

<ng-template #modalFooterTemplateRef>
  <div class="py-3 flex items-center justify-center">
    <button
      mat-flat-button
      color="primary"
      class="medium-size mt-2 w-[15rem!important]"
      data-qa="checkout-checkin-save-button"
      type="submit"
      (click)="onSubmit()"
    >
      {{ 'Save' | translate }}
    </button>
  </div>
</ng-template>
